import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'General',
  attributeName: 'whitLabelTags',

  fields: [
    {
      attributeName: 'name',
      helpText: 'Name of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',

    },
    {
      attributeName: 'description',
      helpText: 'Description of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Description',
      placeholder: 'Description...',

    },

  ],
};
